export interface FortnoxConnectionStatusDto {
  /** Julo has enabled Fortnox for the store; when false the CRM hides the card. */
  enabled: boolean
  connected: boolean
  companyName: string | null
  organizationNumber: string | null
  connectedAt: string | null
}

export interface FortnoxConnectUrlDto {
  url: string
}

/** Set by the API on the CRM redirect after Fortnox's OAuth callback. */
export const FORTNOX_CONNECTION_RESULT_PARAM = "fortnox"

export enum FortnoxConnectionResult {
  CONNECTED = "connected",
  ERROR = "error",
  /** The store approved a different Fortnox company than it is connected to. */
  COMPANY_MISMATCH = "company-mismatch",
}
